// Remove all spaces // Spaces Only
export function trimAll(str) {
  return  str.trim().replace(/\s+/g, '')
}
export default trimAll